// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1ZxNT","colCheckbox":"styles_colCheckbox__SQDCJ"};